import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Aboutclientkinekt() {
  return (
    <section className="about-client-kinekt p-100">
      <Container>
        <div className="about-client-box">
          <Row>
            <Col
              xs={12}
              md={5}
              lg={5}
              xl={5}
              xxl={5}
              className="order-2 order-md-1"
            >
              <StaticImage
                src="../../../images/case-studies/kinekt-new/about-client.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={503}
                height={620}
              />
            </Col>
            <Col
              xs={12}
              md={6}
              lg={6}
              xl={6}
              xxl={6}
              className="offset-md-1 order-1 order-md-2"
            >
              <h2 className="head-h2-kinekt">
                About <span style={{ color: "#20A2BE" }}>Client</span>
              </h2>
              <div className="client-info">
                <p>Country: London, UK</p>
              </div>
              <div className="client-info">
                <p>Industry: Medical</p>
              </div>
              <div className="client-info">
                <p>Work duration: 3 Months</p>
              </div>
              <div className="client-square-info">
                <h6>Team composition</h6>
                <p>1 Mobile developer, 1 mobile designer, 1 project manager</p>
              </div>
              <div className="client-square-info">
                <h6>Project Scope and technology</h6>
                <p>
                  Mobile app development, react native development, Business
                  processes optimising
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Aboutclientkinekt;
